import { Button } from "antd";
import React from "react";
import { ReactComponent as Minus } from "../../../../assets/icons/ButtonIconMinus.svg";
import { theme } from "../../../../theme";

interface Props {
  onClick?: () => void;
  fill?: string;
  stroke?: string;
  disabled?: boolean;
}
const DeleteButton: React.FC<Props> = ({ onClick, fill, stroke, disabled }) => {
  return (
    <Button
      size="small"
      ghost
      danger
      style={{
        display: "flex",
        alignItems: "center",
      }}
      onClick={onClick}
      disabled={disabled}
    >
      <Minus
        fill={fill || theme.colors.red3}
        stroke={stroke}
        style={{ marginRight: "4px" }}
      />{" "}
      삭제
    </Button>
  );
};

export default DeleteButton;
